import { jsx as _jsx } from "react/jsx-runtime";
/*
 *  Copyright 2020 Adobe
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */
// This is component copied from aem-react-core-wcm-components-spa libary, as we cannot import and reuse libary after upgrade to aem-react-editable-components v2,
import * as React from "react";
const isBrowser = (() => {
    try {
        return typeof window !== "undefined";
    }
    catch (err) {
        return false;
    }
})();
export const withStandardBaseCssClass = (Component, defaultBaseCssClass) => {
    return (props) => {
        const baseCssClass = props.baseCssClass;
        const toBeUsedCssClass = baseCssClass && baseCssClass.trim().length > 0 ? baseCssClass : defaultBaseCssClass;
        const mergedProps = {
            ...props,
            baseCssClass: toBeUsedCssClass,
        };
        return _jsx(Component, { ...mergedProps });
    };
};
export const withAuthorPanelSwitch = (Component) => {
    return class extends React.Component {
        //@ts-ignore
        messageChannel;
        constructor(props) {
            super(props);
            this.state = {};
            //@ts-ignore
            if (isBrowser && window.Granite && window.Granite.author && window.Granite.author.MessageChannel) {
                //@ts-ignore
                this.messageChannel = new window.Granite.author.MessageChannel("cqauthor", window);
                this.callback = this.callback.bind(this);
            }
        }
        callback(message) {
            // @ts-ignore
            if (message.data && message.data.id === this.props.cqPath) {
                if (message.data.operation === "navigate") {
                    const index = message.data.index;
                    this.setState({
                        activeIndexFromAuthorPanel: index,
                    });
                }
            }
        }
        componentDidMount() {
            if (this.messageChannel) {
                this.messageChannel.subscribeRequestMessage("cmp.panelcontainer", this.callback);
            }
        }
        componentWillUnmount() {
            if (this.messageChannel) {
                this.messageChannel.unsubscribeRequestMessage("cmp.panelcontainer", this.callback);
            }
        }
        render() {
            return _jsx(Component, { ...this.props, activeIndexFromAuthorPanel: this.state.activeIndexFromAuthorPanel });
        }
    };
};
